export default "306e979d8f393740.png"